import { useCallback } from 'react';
import { Source } from '../../constants/Source';
import { useMMGRSettingsWithTokenOverride } from '../hoc/withMMGRSettings/withMMGRSettings';
import {
  getAdapter,
  getAdapterWithAdapterSettings,
  getItemAdapter,
  mmgrSettingsToAdapterSettings,
} from '../media-manager-sdk/getAdapter';

export const useAdapter = (source: Source, siteMediaToken?: string) => {
  const mmgrSettings = useMMGRSettingsWithTokenOverride(siteMediaToken);
  const adapterSettings = mmgrSettingsToAdapterSettings(source, mmgrSettings);
  return getAdapterWithAdapterSettings(source, adapterSettings);
};

export const useGetAdapter = (siteMediaToken?: string) => {
  const mmgrSettings = useMMGRSettingsWithTokenOverride(siteMediaToken);
  return useCallback((source) => getAdapter(source, mmgrSettings), [mmgrSettings]);
};

export const useGetItemAdapter = (siteMediaToken?: string) => {
  const mmgrSettings = useMMGRSettingsWithTokenOverride(siteMediaToken);
  return useCallback((item) => getItemAdapter(item, mmgrSettings), [mmgrSettings]);
};
